import React from "react";
import apiClient from "../../utils/api.js";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout.js";

function Admin() {
    const [orgs, setOrgs] = React.useState([]);
    const [subscriptions, setSubscriptions] = React.useState([]);

    React.useEffect(() => {
        apiClient.listOrgs().then((response) => {
            const sortedOrgs = response.organizations.sort((a, b) => {
                const bVal = new Date(b.createdAt).getTime()
                const aVal = new Date(a.createdAt).getTime()
                return bVal - aVal;
            })
            setOrgs(sortedOrgs);
        })

        apiClient.listSubscriptions().then((response) => {
            const sortedSubs = response.subscriptions.sort((a, b) => {
                const bVal = new Date(b.createdAt).getTime()
                const aVal = new Date(a.createdAt).getTime()
                return bVal - aVal;
            })
            setSubscriptions(sortedSubs);
        })
    }, [])


    const content = <>
        <h2>Organizations</h2>
        <table>
            <thead>
                <tr>
                    {/*<th>Organization ID</th>*/}
                    <th>User Emails</th>
                    <th># databases</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {orgs.map((org, index) => {
                    const emailsList = org.users.map((user) => user.email);
                    const emails = emailsList.join(", ");
                    const created = new Date(org.createdAt).toISOString().split('T')[0];
                    return (
                        <tr key={index}>
                            {/*<td>{org.id}</td>*/}
                            <td>{emails}</td>
                            <td>{org.databases.length}</td>
                            <td>{created}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>

        <h2>Subscriptions</h2>
        <table>
            <thead>
                <tr>
                    <th>Org ID</th>
                    <th>Paddle URL</th>
                    <th>Email</th>
                    <th>CreatedAt</th>
                    <th>Status</th>
                    <th>Tier</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {subscriptions.map((sub, index) => {
                    return (
                        <tr key={index}>
                            <td>{sub.organizationId}</td>
                            <td>
                                <a href={sub.customerPaddleUrl} target="_blank" rel="noopener noreferrer">
                                    {sub.customerPaddleId}
                                </a>
                            </td>
                            <td>{sub.email}</td>
                            <td>{new Date(sub.createdAt).toISOString().split('T')[0]}</td>
                            <td>{sub.status}</td>
                            <td>{sub.items[0].priceName}</td>
                            <td>{sub.items[0].unitPriceAmount} {sub.items[0].unitPriceCurrency}</td>
                        </tr>
                    )
                }
                )}
            </tbody>
        </table>
    </>

    return <FullWidthLayout title={"Internal Admin"} mainContent={content} />
}

export default Admin;